module.exports = __webpack_public_path__ + "static/media/StepWeight.4c6da58a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/StepWeight.jpg
// module id = 495
// module chunks = 0